import api from "./axios";

export const getFaqCategories = async () => {
  return await api.get("/api/web-api/public/get-faq-categories");
};
